@if (rows().length) {
  <rt-data-table
    [raised]="false"
    [hasZebra]="true"
    [cols]="columns"
    [rows]="rows()"
    [selectable]="false"
    [clickable]="false"
    [cellPadding]="true"
  ></rt-data-table>

  <rt-pagination
    [page]="pagination().page!"
    [pagesCount]="pageCount()"
    (pageChange)="pageChange.emit($event)"
    margin-top-small
    class="pagination"
  >
  </rt-pagination>
}
